import { render, staticRenderFns } from "./ResourceLayout.vue?vue&type=template&id=bc52d6e6&scoped=true&"
import script from "./ResourceLayout.vue?vue&type=script&lang=js&"
export * from "./ResourceLayout.vue?vue&type=script&lang=js&"
import style0 from "./ResourceLayout.vue?vue&type=style&index=0&id=bc52d6e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc52d6e6",
  null
  
)

export default component.exports